import React from "react";
import { Form, Input, Radio, Select, Skeleton } from "antd";
import RadioGroup from "antd/lib/radio/group";
import QuestionPopup from "../../../../common/components/questionPopup/questionPopup";
import PhoneNumberMask from "../../../../common/inputs/AuthorizationInputs";
import PhysicalForm from "./formSections/PhysicalForm";
import LegalForm from "./formSections/LegalForm";
import IndividForm from "./formSections/IndividForm";
import { BankForm } from "./formSections/BankForm";

const { Option } = Select;

const phonePopupInfo = (
  <div>
    По указанному номеру телефона
    <br />в приложении заказчика будет
    <br />
    доступна информация и документы
    <br />
    по заявкам, предложениям, заказам
  </div>
);

const requiredRule = {
  required: true,
  message: "Поле, обязательное для заполнения"
};

const siteRegexp = new RegExp(/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/);


class CustomerCardForm extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.errors && this.props.errors !== prevProps.errors) {
      const { errors } = this.props;

      let obj = {};
      if (
        errors &&
        errors.message || errors.errors
      ) {
        Object.keys(errors.errors).forEach(key => {
          const value = this.props.form.getFieldValue(key);
          obj[key] = {
            value: value,
            errors: [new Error(errors.errors[key])]
          };
        });
      }

      this.props.form.setFields({ ...obj });
    }
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { disabled, onSubjectKeyChange } = this.props;
    const subjectKey = getFieldValue("subjectKey");
    const prefixPhoneCode = getFieldDecorator("phoneCode", {
      initialValue: "+7"
    })(
      <Select
        style={{ width: 78, backgroundColor: "#fff" }}
        dropdownMatchSelectWidth={false}
        optionLabelProp="value"
        placeholder="Код"
        disabled={disabled}
      >
        <Option value="+7">+7 (Россия)</Option>
        <Option value="+380">+380 (Украина)</Option>
        <Option value="+375">+375 (Беларусь)</Option>
        <Option value="+77">+77 (Казахстан)</Option>
        <Option value="+994">+994 (Азербайджан)</Option>
        <Option value="+374">+374 (Армения)</Option>
        <Option value="+995">+995 (Грузия)</Option>
      </Select>
    );
    return (
      <Form layout="inline" className="customer-card-form">
        {this.props.data && Object.keys(this.props.data).length > 0 ? (
          <>
            <div className="customer-card-form__unit">
              <span className="customer-card-form__label">Заказчик:</span>
              {/* Оставил поле скрытым чтобы данные могли передаваться при редактированиии */}
              <div className="customer-card-form__item" hidden>
                {getFieldDecorator("subjectKey")(
                  <RadioGroup
                    name="subject"
                    disabled
                    onChange={onSubjectKeyChange}
                  >
                    <Radio value="physical">Физическое лицо</Radio>
                    <Radio value="legal">Юридическое лицо</Radio>
                    <Radio value="individ">ИП</Radio>
                  </RadioGroup>
                )}
              </div>
              <div className="customer-card-form__item">
                {getFieldDecorator("subject")(<Input disabled />)}
              </div>
              {/*)}*/}
            </div>
            {subjectKey === "physical" ? (
              /* Поля для физ лица */
              <PhysicalForm form={this.props.form} disabled={disabled} />
            ) : subjectKey === "legal" ? (
              /* Поля для юр лица */
              <LegalForm
                form={this.props.form}
              />
            ) : subjectKey === "individ" ? (
              /* Поля для ИП */
              <IndividForm
                form={this.props.form}
              />
            ) : null}
            <div className="customer-card-form__unit double-margin">
              <span className="customer-card-form__label">
                Номер телефона аккаунта:
              </span>
              <div className="customer-card-form__item customer-card-form__phone">
                <Form.Item>
                  {getFieldDecorator("phone", {
                    rules: [requiredRule]
                  })(
                    <PhoneNumberMask
                      disabled={disabled}
                      autoComplete="off"
                      name="phoneNumber"
                      mask="(###) ###-##-##"
                      addonBefore={prefixPhoneCode}
                      maxLength={15}
                      placeholder="Укажите номер телефона"
                    />
                  )}
                </Form.Item>
                {!disabled && (
                  <QuestionPopup
                    width="24px"
                    height="24px"
                    trigger="click"
                    fill="#00a8ff"
                    position="bottomLeft"
                    style={{ marginLeft: 16 }}
                  >
                    {phonePopupInfo}
                  </QuestionPopup>
                )}
              </div>
            </div>
            <div className="customer-card-form__unit">
              <span className="customer-card-form__label">E-mail:</span>
              <div className="customer-card-form__item">
                <Form.Item>
                  {getFieldDecorator("email", {
                    rules: [requiredRule]
                  })(
                    <Input
                      disabled={disabled}
                      className="customer-card-form__input"
                      placeholder="Укажите e-mail"
                      style={{ width: 368 }}
                    />
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="customer-card-form__unit double-margin">
              <span className="customer-card-form__label">Сайт:</span>
              <div className="customer-card-form__item">
                <Form.Item>
                  {getFieldDecorator("site", {
                    rules: [
                      {
                        validator: (rule, value, callback) => {
                          if (value && !value.match(siteRegexp)) {
                            callback('Введите адрес в формате sitename.com');
                          } else {
                            callback()
                          }
                        }
                      }
                    ]
                  })(
                    <Input
                      disabled={disabled}
                      className="customer-card-form__input"
                      placeholder="Укажите сайт"
                      style={{ width: 368 }}
                    />
                  )}
                </Form.Item>
              </div>
            </div>

            {subjectKey && (
              <BankForm form={this.props.form} disabled={disabled} />
            )}
          </>
        ) : (
          <Skeleton active />
        )}
      </Form>
    );
  }
}

export default Form.create({
  name: "AddCustomerForm",
  onFieldsChange(props, fields) {
    props.handleFieldsChange(fields)
  },
  mapPropsToFields(props) {
    let obj = {};
    if (props) {
      let { data } = props;

      if (data) {
        Object.keys(data).forEach(key => {
          obj[key] = Form.createFormField({
            ...(!props.disabled ? data[key] : {}),
            value: !props.disabled
              ? props.getValueByFieldName(key, data[key].value)
              : props.getValueByFieldName(key, data[key])
          });
        });
      }
    }

    return obj;
  }
})(CustomerCardForm);
